import {combineReducers} from 'redux'
import UserReducer from '../reducers/UserReducer'
import JobsReducer from '../reducers/JobsReducer'
import AdminReducer from '../reducers/AdminReducer'
import JobReducer from '../reducers/JobReducer'
import SettingsReducer from '../reducers/SettingsReducer'

const rootReducer = combineReducers({
  user: UserReducer,
  jobs: JobsReducer,
  admin: AdminReducer,
  job: JobReducer,
  settings:SettingsReducer,
})

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducer.js